import { reactive } from 'vue'
import api from '@/services/api'

const sessionBootstrap = reactive({
  currentUser: null,
  userType: null,
  staffRole: null,
  profile: null,
  ready: false,
  loading: false,
  error: null
})

let loadPromise = null

function applyAuthUser(authUser) {
  sessionBootstrap.currentUser = authUser || null
  sessionBootstrap.userType = authUser?.type || null
  sessionBootstrap.staffRole = authUser?.staff_role || null
}

async function buildClinicManagerProfile(authUser) {
  let managerProfile = authUser

  try {
    const meResponse = await api.get('/users/me/')
    if (meResponse.data) {
      managerProfile = {
        ...authUser,
        ...meResponse.data,
        type: authUser.type,
        staff_role: authUser.staff_role || null
      }
    }
  } catch (_) {
    managerProfile = authUser
  }

  const assignedClinic = authUser?.assigned_clinic
  let clinicData = null

  if (assignedClinic && typeof assignedClinic === 'object') {
    clinicData = assignedClinic
  } else if (assignedClinic) {
    try {
      const clinicResponse = await api.get(`/clinics/${assignedClinic}/`)
      clinicData = clinicResponse.data || null
    } catch (_) {
      clinicData = null
    }
  }

  return {
    user: managerProfile,
    clinic: clinicData,
    specialization: 'Менеджер клиники'
  }
}

async function loadProfile(authUser) {
  if (!authUser) return null

  if (authUser.type === 'doctor') {
    const response = await api.getDoctorProfile()
    return response.data || null
  }

  if (authUser.type === 'nurse') {
    const response = await api.getNurseProfile()
    return response.data || null
  }

  if (authUser.type === 'staff' && authUser.staff_role === 'clinic_manager') {
    return buildClinicManagerProfile(authUser)
  }

  return null
}

export function resetSessionBootstrap() {
  sessionBootstrap.currentUser = null
  sessionBootstrap.userType = null
  sessionBootstrap.staffRole = null
  sessionBootstrap.profile = null
  sessionBootstrap.ready = false
  sessionBootstrap.loading = false
  sessionBootstrap.error = null
  loadPromise = null
}

export async function loadSessionBootstrap({ force = false } = {}) {
  if (loadPromise) {
    return loadPromise
  }

  if (!force && sessionBootstrap.ready) {
    return sessionBootstrap
  }

  sessionBootstrap.loading = true
  sessionBootstrap.error = null

  loadPromise = (async () => {
    try {
      const response = await api.checkAuth()
      const isAuthenticated = response.data?.isAuthenticated !== false
      const authUser = isAuthenticated ? (response.data?.user || null) : null

      applyAuthUser(authUser)
      sessionBootstrap.profile = await loadProfile(authUser)
      sessionBootstrap.ready = true

      return sessionBootstrap
    } catch (error) {
      resetSessionBootstrap()
      sessionBootstrap.error = error
      throw error
    } finally {
      sessionBootstrap.loading = false
      loadPromise = null
    }
  })()

  return loadPromise
}

export function refreshSessionBootstrap() {
  return loadSessionBootstrap({ force: true })
}

sessionBootstrap.refresh = refreshSessionBootstrap

export default sessionBootstrap
